export default function RedotCircleFlag({code, size = 23}) {
  if (!code) return null;

  let flagUrl;
  const nationCode = String(code).toLowerCase();
  if (nationCode === 'tw') {
    flagUrl = `/images/logo.png`;
  } else {
    flagUrl = `/images/flags/${nationCode}.svg`;
  }

  return (
    <img src={flagUrl} width={size}/>
  );
}
